var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserManagement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.2a3.2 3.2 0 1 1 0-6.4 3.2 3.2 0 0 1 0 6.4zm0-4.8a1.6 1.6 0 1 0 0 3.199 1.6 1.6 0 0 0 0-3.2zm4.8 10.4a4.8 4.8 0 0 0-9.6 0 .8.8 0 1 0 1.6 0 3.2 3.2 0 1 1 6.4 0 .8.8 0 1 0 1.6 0zm0-12a3.2 3.2 0 1 1 0-6.4 3.2 3.2 0 0 1 0 6.4zm0-4.8a1.6 1.6 0 1 0 0 3.2 1.6 1.6 0 0 0 0-3.2zm4.8 10.4a4.805 4.805 0 0 0-4.8-4.8.8.8 0 0 0 0 1.6 3.2 3.2 0 0 1 3.2 3.2.8.8 0 1 0 1.6 0zM7.2 8.8a3.2 3.2 0 1 1 0-6.4 3.2 3.2 0 0 1 0 6.4zm0-4.8a1.6 1.6 0 1 0 0 3.2 1.6 1.6 0 0 0 0-3.2zM4 14.4a3.2 3.2 0 0 1 3.2-3.2.8.8 0 0 0 0-1.6 4.805 4.805 0 0 0-4.8 4.8.8.8 0 1 0 1.6 0z",
    fill: "#161338"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserManagement);
export default __webpack_public_path__ + "static/media/userManagement.03644dd5fe06c4546028c11f78bf1685.svg";
export { ForwardRef as ReactComponent };